import moment from 'moment';
import {
  GRANULARITY,
  FIVE_MIN,
  FIFTEEN_MIN,
  THIRTY_MIN,
  HOUR,
  SIX_HOURS,
  DAY,
  WEEK,
  MONTH,
  THREE_MONTHS,
} from '@utils/granularity';
const { PT10S, PT1M, PT5M, PT15M, PT30M, PT1H, PT6H, PT12H, P1D, P1W, P30D } = GRANULARITY;
import { DATE_SHORTCUTS } from '@utils/constants';
import { get } from 'lodash';

export const GranularityMap = {
  [PT10S]: { label: '10s', value: PT10S, step: 10, unit: 'seconds' },
  [PT1M]: { label: '1m', value: PT1M, step: 1, unit: 'minutes' },
  [PT5M]: { label: '5m', value: PT5M, step: 5, unit: 'minutes' },
  [PT15M]: { label: '15m', value: PT15M, step: 15, unit: 'minutes' },
  [PT30M]: { label: '30m', value: PT30M, step: 30, unit: 'minutes' },
  [PT1H]: { label: '1h', value: PT1H, step: 1, unit: 'hours' },
  [PT6H]: { label: '6h', value: PT6H, step: 6, unit: 'hours' },
  [PT12H]: { label: '12h', value: PT12H, step: 12, unit: 'hours' },
  [P1D]: { label: '1d', value: P1D, step: 1, unit: 'days' },
  [P1W]: { label: '7d', value: P1W, step: 7, unit: 'days' },
  [P30D]: { label: '30d', value: P30D, step: 30, unit: 'days' },
};

export const getCompareIntervalForDimensionTable = (currentSlicedInterval) => {
  const { to, from, granularity } = currentSlicedInterval;
  const currentSliceIntervalDiff = to - from;
  const compareInterval = {
    to: from,
    from: from - currentSliceIntervalDiff,
    granularity: granularity
  };

  return compareInterval;
}

export const allowedGranularities = (interval) => {
  const { from, to } = interval;
  const shortcut = get(interval, 'shortcut', null);

  const diff = moment(to).diff(moment(from), 'm');
  const relativeDiff = moment().diff(from, 'm');
  let values: any = [];

  // PT1M is supported up to a month
  if (relativeDiff < MONTH) {
    switch (true) {
      case shortcut && shortcut === DATE_SHORTCUTS.last15Mins:
        values = [PT10S];
        break;
      case diff <= FIVE_MIN:
        values = [PT1M];
        break;
      case diff <= FIFTEEN_MIN:
        values = [PT1M, PT5M];
        break;
      case diff <= THIRTY_MIN:
        values = [PT1M, PT5M, PT15M];
        break;
      case diff <= HOUR:
        values = [PT1M, PT5M, PT15M, PT30M];
        break;
      case diff <= SIX_HOURS:
        values = [PT1M, PT5M, PT15M, PT30M, PT1H];
        break;
      case diff <= DAY:
        values = window.isGlobalAccount ? [PT1H] : [PT1M, PT5M, PT15M, PT30M, PT1H];
        break;
    }
  }

  // relative diff > MONTH
  if (values.length === 0) {
    switch (true) {
      case diff <= HOUR:
        values = [PT1H];
        break;
      case diff <= DAY:
        values = [PT1H];
        break;
      case diff <= WEEK:
        values = [PT1H, PT6H, PT12H, P1D];
        break;
      case diff <= MONTH:
        values = [PT1H, PT6H, PT12H, P1D, P1W];
        break;
      case diff <= THREE_MONTHS:
        values = [P1D, P1W, P30D];
        break;
      case diff > THREE_MONTHS:
        values = [P1D, P1W, P30D];
        break;
    }
  }

  return values;
};
